import React from "react";
import OpenLibraryMcq from "./OpenLibraryMcq";
import OpenLibraryImg from "./OpenLibraryImg";

const OpenLibraryPage = ({
  filter,
  setClick,
  setClick1,
  setQuestions,
  selectedQuestion,
  selQueID,
  questions
}) => {
  console.log(selQueID)
  const handleAddingQuestions = () => {
    setQuestions((prev) => [...prev, ...selectedQuestion]);
    setClick((prev) => !prev);
    setClick1((prev) => !prev);
    for (const que of selQueID) {
      localStorage.removeItem(`isChecked_${que}`);
    }
  };
  return (
    <>
      <div className="library_transprant_body">
        <img
          src="/images/cross-circle3.svg"
          className="library_close_btn"
          alt=""
          onClick={(e) => setClick(false)}
        />
        <div className="p-4 library_container">
          <span className="select_library_header">Select From Library</span>

          <div className="mt-3 d-flex gap-5">
            <img
              src="/images/back_arrow.svg"
              alt=""
              onClick={(e) => setClick(false)}
            />
            <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Class</span>
              <span className="hw_libriry_subheading">
                {filter?.standard?.name}
              </span>
            </div>
            <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Section</span>
              <span className="hw_libriry_subheading">
                {filter?.section?.name}
              </span>
            </div>
            <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Subject</span>
              <span className="hw_libriry_subheading">
                {filter?.subject?.name}
              </span>
            </div>
            {/* Hide chapter, skill, domain */}
            {/* <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Chapter</span>
              <span className="hw_libriry_subheading">
                {filter?.bookChapter?.chapterName}
              </span>
            </div> */}
            {/* <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Knowledge Domain</span>
              <span className="hw_libriry_subheading">
                {filter?.domain?.name}
              </span>
            </div> */}
            {/* <div className=" hw_open_liberary_box">
              <span className="hw_libriry_heading">Skills</span>
              <span className="hw_libriry_subheading">
                {filter?.skill?.name}
              </span>
            </div> */}
          </div>
          <div className="mt-4 d-flex justify-content-between">
            <span className="open_libriry_topic_name">
              {filter.name}
            </span>
            <button
              onClick={handleAddingQuestions}
              className="btn library_next_btn"
            >
              Selected
            </button>
          </div>
          <div className=" mt-3 open_library_container">
            {selectedQuestion &&
              selectedQuestion.length > 0 &&
              selectedQuestion.map((sQuestion, index) =>
                sQuestion?.question_type === "false" ? (
                  <OpenLibraryMcq
                    key={index}
                    filter={filter}
                    questionNumber={index}
                    sQuestion={sQuestion}
                  />
                ) : (
                  <OpenLibraryImg
                    key={index}
                    filter={filter}
                    questionNumber={index}
                    sQuestion={sQuestion}
                  />
                )
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenLibraryPage;
